import React,{useState,useEffect} from 'react';
import { FaAngleRight } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import ReactGa from 'react-ga';
import {useSelector} from 'react-redux';
import logoImg from '../../assets/images/aprioriblanco.png';

const pad = (value) => String(value === '' || value === undefined || value === null ? 0 : value).padStart(2, '0');

export default function Banner(props){
    const reduxUser = useSelector(state => state.user);
    const [user, setUser] = useState({});
    const {tipo, idEvento} = props;
    const [dateEvent, setDateEvent] = useState(new Date(props.hora));
    const [cronometro, setCronometro] = useState({dia:'00',hora:'00',minuto:'00',segundo:'00'})
    const titulo = props.titulo || '';

    function showRemaining(endDate) {
        const now = new Date();
        const distance = endDate - now;
        if (distance < 0) {
            return;
        }
        const _second = 1000;
        const _minute = _second * 60;
        const _hour = _minute * 60;
        const _day = _hour * 24;
        setCronometro({
            dia: pad(Math.floor(distance / _day)),
            hora: pad(Math.floor((distance % _day) / _hour)),
            minuto: pad(Math.floor((distance % _hour) / _minute)),
            segundo: pad(Math.floor((distance % _minute) / _second))
        })
    }
    useEffect(()=>{
        const end = new Date(props.hora);
        showRemaining(end);
        const timer = setInterval(() => showRemaining(end), 1000);
        return () => {
            clearInterval(timer);
        }
    }, [props.hora]);

    const buttonAnalytics = (btn) => {
        ReactGa.event({
            category: 'Button',
            action: 'Click button '+btn+' en home ',
        })
    }

    useEffect(() => {
      setUser(reduxUser);
    }, [reduxUser])
    useEffect(() => {
        setDateEvent(new Date(props.hora));
    }, [props.hora])

    return(
    <>
        <div className="h-screen w-full background-banner text-white flex justify-center items-center flex-col px-5 md:px-8 bg-center">
            <div className="landing-wrap relative z-10 flex flex-col items-center text-center pt-16">
            <p className="uppercase tracking-widest text-sm text-gray-300">Tu futuro está a punto de cambiar con nosotros</p>
            
            {
                tipo === 'evento' ?<p className="text-primary font-semibold mt-4 text-lg">Próximo Evento</p>:
                <p className="text-primary font-semibold mt-4 text-lg">Próximo Examen</p>
            }
            <h1 className={`text-3xl md:text-5xl lg:text-6xl font-bold mt-2 leading-tight ${titulo.length>30?'lg:text-5xl':'lg:text-6xl'} text-white w-full md:w-4/5`}>{titulo}</h1>
            <div className="flex mt-8">
              {
                new Date() < dateEvent ?
                <div className="flex flex-row">
                  <div className="countdown-cell mx-1 md:mx-2"><div className="text-4xl md:text-5xl font-bold text-white">{cronometro.dia}</div><div className="text-xs md:text-sm text-gray-300 mt-1">Días</div></div>
                  <div className="countdown-cell mx-1 md:mx-2"><div className="text-4xl md:text-5xl font-bold text-white">{cronometro.hora}</div><div className="text-xs md:text-sm text-gray-300 mt-1">Horas</div></div>
                  <div className="countdown-cell mx-1 md:mx-2"><div className="text-4xl md:text-5xl font-bold text-white">{cronometro.minuto}</div><div className="text-xs md:text-sm text-gray-300 mt-1">Minutos</div></div>
                  <div className="countdown-cell mx-1 md:mx-2"><div className="text-4xl md:text-5xl font-bold text-primary">{cronometro.segundo}</div><div className="text-xs md:text-sm text-gray-300 mt-1">Segundos</div></div>
                </div>
                :
                <div className='flex flex-col text-center bg-white bg-opacity-10 rounded-2xl px-8 py-6'>
                <p className="text-3xl font-bold">Examen finalizado</p>
                <p className="text-base text-gray-300 mt-2">
                  Estamos preparando todo para la próxima convocatoria.
                </p>
                </div>
                
              }  
            </div>
            <div className="flex mt-8 flex-col items-center md:flex-row" >
                <Link onClick={()=>buttonAnalytics('Convocatorias')} className="text-center cursor-pointer py-3 rounded-full px-6 bg-white text-fondo font-semibold mx-2 mt-3 md:mt-0 hover:bg-gray-200" to="/convocatoria">Convocatorias</Link>
                {
                    tipo === 'evento' ?
                    <Link
                    onClick={()=>buttonAnalytics('Ver Detalles')}
                        className="mx-2 mt-3 md:mt-0 text-center cursor-pointer py-3 rounded-full px-6 bg-primary flex flex-row items-center font-semibold hover:bg-white hover:text-fondo" 
                        to={`/events/${idEvento}`}
                    >Ver Detalles< FaAngleRight  className="text-white ml-1"/></Link>:
                    <Link 
                    onClick={()=>buttonAnalytics('Ver Detalles')}
                    className="mx-2 mt-3 md:mt-0 text-center cursor-pointer py-3 rounded-full px-6 bg-primary flex flex-row items-center font-semibold hover:bg-white hover:text-fondo" to={{
                        pathname: `/Details`,
                        search: (props.data && (props.data.id || props.data.idExamen)) ? `?idExam=${props.data.id || props.data.idExamen}` : undefined,
                        data: props.data
                    }}>Prueba gratis ahora <FaAngleRight className="ml-1"/></Link>
                }

            </div>
            {
              user.user===null?
              <Link className="text-center cursor-pointer py-2 rounded-full border-2 border-primary px-6 text-white mt-4 hover:bg-primary" to="/login">Iniciar sesión</Link>
              :
              <Link className="text-center cursor-pointer py-2 rounded-full border-2 border-primary px-6 text-white mt-4 hover:bg-primary" to="/profile">Ir a perfil</Link>
            }
            </div>
        </div>
        <div className="bg-primary px-6 md:px-12 py-4 text-xl flex justify-between flex-col md:flex-row items-center">
            <p
                className='text-white text-center font-medium text-base md:text-xl mb-3 md:mb-0'
            >
                Ahora Apriori te ayuda para el examen de ingreso a las ESFM
            </p>
            <Link to="/teacher" className="bg-white text-primary px-5 py-2 rounded-full inline-block font-semibold hover:bg-fondo hover:text-white">Comienza ahora</Link>
        </div>
        <div className="bg-fondo px-6 md:px-12 py-10 text-xl flex justify-center flex-col items-center">
            <img className='w-28 my-2' src={logoImg} alt="Apriori"/>
            <p  className="text-gray-300 text-center font-normal text-base md:text-xl my-2 max-w-3xl leading-relaxed">
                Nuestra plataforma está diseñada de forma minuciosa para que obtengas más seguridad y confianza en cada examen.
            </p>
        </div>
    </>
    );
};
